import api from "./api";
import { AuthResponse } from "../types/Models";

export const handleSwitchProfile = async (
  roleId: number,
): Promise<AuthResponse> => {
  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.post<AuthResponse>(
      "/switch-profile",
      { role_id: roleId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    sessionStorage.setItem("authToken", response.data.token);

    return response.data;
  } catch (error) {
    throw new Error("Failed to switch profile");
  }
};
